export default __webpack_public_path__ + "static/media/logo.fc56e729.svg";